import { render, staticRenderFns } from "./CustomArrayInput.vue?vue&type=template&id=7065f146"
import script from "./CustomArrayInput.vue?vue&type=script&lang=js"
export * from "./CustomArrayInput.vue?vue&type=script&lang=js"
import style0 from "./CustomArrayInput.vue?vue&type=style&index=0&id=7065f146&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
